const Arrow = () => {
  return (
    <svg
      className="size-24px absolute left-[-7.5px] bottom-[-1px]"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_3508_60105)">
        <path
          d="M6.49858 -28C6.49858 -34.6274 11.8712 -40 18.4986 -40H248.499C255.126 -40 260.499 -34.6274 260.499 -28V12C260.499 18.6274 255.126 24 248.499 24H2.09955C1.25752 24 0.792451 23.0229 1.32343 22.3694L3.81194 19.3066C5.54989 17.1676 6.49858 14.4956 6.49858 11.7395V8V-8V-28Z"
          fill="white"
        />
        <path
          d="M248.498 23V24H2.09897V23H248.498ZM259.498 12V-28C259.498 -34.0751 254.574 -39 248.498 -39H18.4984C12.4233 -39 7.49838 -34.0751 7.49838 -28V11.7393C7.49838 14.725 6.471 17.6202 4.58823 19.9375L2.09897 23V24C1.30962 23.9997 0.85195 23.1409 1.23569 22.4951L1.32358 22.3691L3.81186 19.3066C5.54978 17.1676 6.49838 14.4953 6.49838 11.7393V-28C6.49838 -34.5239 11.7045 -39.8319 18.1888 -39.9961L18.4984 -40H248.498C255.126 -40 260.498 -34.6274 260.498 -28V12C260.498 18.5239 255.292 23.8319 248.808 23.9961L248.498 24V23C254.574 23 259.498 18.0751 259.498 12Z"
          fill="black"
          fill-opacity="0.16"
        />
      </g>
      <defs>
        <clipPath id="clip0_3508_60105">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Arrow;
